import { Typography } from 'antd';
import { useSystemDatetime } from 'contexts';
import { memo } from 'react';
import { TIME_FORMAT } from 'utils';

function ElectronicClock() {
  const { datetime } = useSystemDatetime();

  return (
    <div className='rounded-full bg-textHoverBg px-4 leading-10'>
      <Typography.Text
        style={{
          font: 'normal normal 600 20px/20px Orbitron',
          letterSpacing: '2px'
        }}
      >
        {datetime.format(TIME_FORMAT)}
      </Typography.Text>
    </div>
  );
}

export default memo(ElectronicClock);
